"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USERS_PERMISSIONS_UPDATED = void 0;
var USERS_PERMISSIONS_UPDATED = exports.USERS_PERMISSIONS_UPDATED = {
  name: 'Permissions updated',
  required: ['type']
};
//# sourceMappingURL=events.js.map